export default __webpack_public_path__ + "static/media/visualiser-carte.2a337fa5.jpg";